/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import * as moment from 'moment';
import 'moment-timezone';

import template from './creative-set-bulk-action-modal.component.html';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED],
  selector: 'adn-creative-set-bulk-action-modal',
  template
})
export class CreativeSetBulkActionModalComponent implements OnInit {
  /** Set via BsModalService initialState */
  list: any;

  item: any = {
    name: '{currentName}',
    objectives: {},
    modStartDate: null,
    modEndDate: null,
    userState: null
  };
  form: any = {};
  editing: any = {};
  count = 0;
  isSelfService = false;
  isAxAdvertiser = false;
  isLockedDown = false;

  private newEndDate = true;

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    this.count = _.keys(this.selection()).length;
    this.isSelfService = this.LocalUserPermissions.isSelfService();
    this.isAxAdvertiser = this.LocalUserPermissions.isAxAdvertiser();
  }

  onEndDateChange(): void {
    if (!this.newEndDate || !this.item.modEndDate) {
      return;
    }
    const networkTimezone = this.LocalNetworkProfile.get('timeZone') || 'utc';
    const defaultEndDayStart = moment(this.item.modEndDate).tz(networkTimezone).startOf('day');
    // Keep an adjusted time if the user changed time before the date.
    if (moment(defaultEndDayStart).isSame(this.item.modEndDate)) {
      this.item.modEndDate = moment(this.item.modEndDate).tz(networkTimezone).endOf('day').toDate();
    }
    this.newEndDate = false;
  }

  apply(): void {
    const creativeSets = _.map(this.selection(), (v: any, k: string) => {
      const obj: any = {id: k};

      if (this.editing.name) {
        obj.name = this.item.name.replace('{currentName}', v.name);
      }
      if (this.editing.userState && this.item.userState) {
        obj.userState = this.item.userState;
      }
      // Match creative-set-edit-page: date-time-picker already uses network TZ.
      if (this.editing.startDate) {
        obj.startDate = _.isDate(this.item.modStartDate) ? this.item.modStartDate : null;
      }
      if (this.editing.endDate) {
        obj.endDate = _.isDate(this.item.modEndDate) ? this.item.modEndDate : null;
      }

      return obj;
    });

    if (_.isFunction(this.list?.saveMiscBulkAction)) {
      this.list.saveMiscBulkAction(creativeSets).subscribe({
        next: () => this.bsModalRef.hide(),
        error: (response: any) => {
          this.form.apiErrors = response?.data?.errors || response?.data || [];
          this.form.bulkError = true;
        }
      });
      return;
    }
    this.list.miscBulkAction(
      {close: () => this.bsModalRef.hide()}, this, creativeSets, null,
      {ignoreProduct: this.LocalNetworkProfile.getDefaults()['defaultIgnoreMarketplaceTargeting']}
    );
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }

  private selection(): Record<string, any> {
    return _.isFunction(this.list?.selected) ? this.list.selected() : this.list?.bulkSelection || {};
  }
}
